var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-page h-100"},[_c('client-only',[_c('Notification',{staticClass:"mt-5 me-3",attrs:{"position":"top right","group":"notify"}})],1),_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }